document.addEventListener('DOMContentLoaded', footerInit);
globalThis.addEventListener('resize', footerNav);

function footerInit() {
  footerNav();
  privacySettings();
}

function nextUid(section) {
  const current = Number(section.dataset.footerPhUid || '0');
  const next = current + 1;
  section.dataset.footerPhUid = String(next);
  return next;
}

function footerNav() {
  const isMobile = globalThis.matchMedia('(max-width: 575.98px)').matches;
  const accordionID = 'footer-nav-accordion';

  const sections = document.querySelectorAll('.site-footer-nav:not(.do-not-collapse)');
  for (const section of sections) {
    const children = Array.from(section.children);

    let menu = children.find((child) =>
      Array.from(child.classList || []).some((cls) => /^menu-.*-container$/.test(/** @type {string} */ (cls)))
    );

    const heading = children.find((child) => child.tagName && child.tagName.toLowerCase() === 'h2');
    if (!heading) continue;

    if (!menu) {
      const buttonCopy = heading.textContent.trim().toLowerCase().replaceAll(' ', '-');
      menu = document.createElement('div');
      menu.className = `menu-${buttonCopy}-container`;
      section.append(menu);
    }

    if (isMobile) {
      setupMobileCollapse(section, heading, menu, accordionID);
    } else {
      teardownMobileCollapse(section, heading, menu);
    }
  }
}

function setupMobileCollapse(section, heading, menu, accordionID) {
  if (!section.classList.contains('collapse-nav')) {
    section.classList.add('collapse-nav');
  }

  const buttonCopy = heading.textContent.trim().toLowerCase().replaceAll(' ', '-');

  let btn = heading.querySelector('button');
  if (btn) {
    btn.setAttribute('data-bs-target', `#${buttonCopy}-collapse`);
    btn.setAttribute('aria-controls', `${buttonCopy}-collapse`);
  } else {
    const buttonText = heading.textContent;
    heading.textContent = '';

    btn = document.createElement('button');
    btn.className = 'collapsed';
    btn.type = 'button';
    btn.setAttribute('data-bs-toggle', 'collapse');
    btn.setAttribute('data-bs-target', `#${buttonCopy}-collapse`);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', `${buttonCopy}-collapse`);
    btn.textContent = buttonText;

    heading.append(btn);
  }

  if (!menu.classList.contains('collapse')) {
    menu.classList.add('collapse');
    menu.id = `${buttonCopy}-collapse`;
  }

  const parent = section.parentElement;
  if (parent) {
    if (!parent.id) {
      parent.id = accordionID;
      parent.dataset.footerAccordion = '1';
    }

    menu.setAttribute('data-bs-parent', `#${parent.id}`);
  }

  let sibling = menu.nextElementSibling;
  while (sibling) {
    const el = sibling;
    sibling = sibling.nextElementSibling;

    if (el.tagName && el.tagName.toLowerCase() === 'script') continue;
    if (el.getAttribute('data-footer-moved') === '1') continue;

    const uid = nextUid(section);
    const placeholder = document.createElement('span');
    placeholder.className = 'footer-collapse-ph';
    placeholder.dataset.phFor = String(uid);
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';

    el.setAttribute('data-footer-moved', '1');
    el.setAttribute('data-footer-ph', String(uid));

    el.before(placeholder);
    menu.append(el);
  }
}

function teardownMobileCollapse(section, heading, menu) {
  menu.removeAttribute('data-bs-parent');
  const parent = section.parentElement;
  if (parent && parent.dataset.footerAccordion === '1') {
    delete parent.dataset.footerAccordion;
    parent.removeAttribute('id');
  }

  const moved = menu.querySelectorAll('[data-footer-moved="1"]');
  for (const el of moved) {
    const uid = el.getAttribute('data-footer-ph');
    if (!uid) continue;

    const placeholder = section.querySelector(`.footer-collapse-ph[data-ph-for="${uid}"]`);
    if (placeholder) {
      placeholder.replaceWith(el);
    } else {
      menu.after(el);
    }

    el.removeAttribute('data-footer-moved');
    el.removeAttribute('data-footer-ph');
  }

  for (const ph of section.querySelectorAll('.footer-collapse-ph')) ph.remove();

  const headingBtn = heading.querySelector('button');
  if (headingBtn) {
    while (headingBtn.firstChild) {
      heading.insertBefore(headingBtn.firstChild, headingBtn);
    }

    headingBtn.remove();
  }

  for (const el of section
    .querySelectorAll('.collapse, .show, .collapsing')) el.classList.remove('collapse', 'show', 'collapsing');

  for (const el of section
    .querySelectorAll('[id$="-collapse"]')) el.removeAttribute('id');

  section.classList.remove('collapse-nav');
}

function privacySettings() {
  const wrapper = document.querySelector('footer .privacy-settings');
  if (!wrapper) return;

  const link = wrapper.querySelector(':scope > a');
  if (!link) return;

  const newLink = document.createElement('a');
  newLink.href = 'javascript:void(0);';
  newLink.setAttribute('role', 'button');
  newLink.setAttribute('onclick', "ketch('showPreferences')");
  newLink.textContent = 'Privacy Settings';

  link.replaceWith(newLink);
}
